import * as React from 'react'
import { withRouter } from 'next/router'
import type { SeriesInfoPropsType, SeriesListPropsType } from '../../models/Series'
import { getSeriesListProps, seriesHasTags } from '../../models/Series'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { SeriesListItemComponent } from '@components/Series/SeriesListItem'
import { PageTitle } from '@components/shared/PageTitle'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import type { TagInfoType } from '../../models/Tag'
import { getPopularTagsAysnc } from '../../models/Tag'
import { colors } from '@components/shared'
import XIcon from '@components/shared/icons/XIcon'

function TagSection (props: { callback: any, filterTags: string[] }): React.ReactNode {
  const [tags, setTags] = React.useState<TagInfoType[]>([])
  React.useEffect((): void => {
    if (tags.length) {
      return
    }
    getPopularTagsAysnc().then((tags: TagInfoType[]): void => {
      const chunks = tags.slice(0, 10)
      setTags(chunks)
    })
  }, [])

  const callback = (tagId: string): void => {
    if (props.filterTags.includes(tagId)) {
      props.callback(props.filterTags.filter((tag: string): boolean => tag !== tagId))
    } else {
      props.callback([...props.filterTags, tagId])
    }
  }

  const clear = (): void => {
    props.callback([])
  }
  return (
    <TagsComponent>
    <TagsContainer>
      {tags.map((tag: TagInfoType, index: number): React.ReactNode => {
        const selected = props.filterTags.includes(tag.id)
        return (
          <TagPillButton $selected={selected} key={`tag-pill-row-series-${index}`} onClick={(): void => callback(tag.id)}>
            {tag.title}
            {selected && <span><XIcon color={colors.white} size={10}/></span>}
          </TagPillButton>
        )
      })}</TagsContainer>
      {!!props.filterTags.length && <Clear onClick={clear}>Clear</Clear>}
    </TagsComponent>)
}

const TagsComponent = styled.div<any>`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
`

const Clear = styled.div<any>`
  color: ${colors.orange};
  text-transform: uppercase;
  font-family: "Good Sans Regular";
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 136%;
  letter-spacing: 0.3px;
  text-decoration-line: underline;
  cursor: pointer;
`

export const TagPillButton = styled.div<any>`
  font-family: "Good Sans Regular";
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  color: ${colors.white};
  border-radius: 100px;
  border: 0.5px solid ${(props: any): string => props.$selected ? colors.orange : colors.white};
  cursor: pointer;
  span {
    margin-left: 8px;
  }

  ${(props: any): any => config(props).media.md`
    padding: 10px 15px 10px 15px;
    font-size: 14px;
  `}
`

const TagsContainer = styled.div<any>`
    display: flex;
    flex-wrap: wrap;
    grid-gap: 8px;
    margin-bottom: 18px;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`

function Series (props: SeriesListPropsType): React.ReactNode {
  const [filterTags, setFilterTags] = React.useState<string[]>([])
  return (
    <DiscoverLayout title={`Explore Top Audiobooks on Dipsea`} canonicalUrl={'https://www.dipseastories.com/audiobooks'}>
      <PageTitle title={props.title}/>
      <TagSection callback={setFilterTags} filterTags={filterTags}/>
      <SeriesContainer series={props.series} filterTags={filterTags}/>
    </DiscoverLayout>
  )
}

function SeriesContainer (props: {series: SeriesInfoPropsType[], filterTags: string[]}): React.ReactNode {
  return <SeriesListContainer>
    {props.series
      .filter((series: SeriesInfoPropsType): boolean => seriesHasTags(props.filterTags, series))
      .map((series: SeriesInfoPropsType): React.ReactNode => (
        <SeriesListItemComponent {...series} key={series.id}/>
      ))}
  </SeriesListContainer>
}

export default withRouter(Series as any) as any

export async function getStaticProps (): Promise<{ props: SeriesListPropsType }> {
  const series = await getSeriesListProps()
  return { props: series }
}

const SeriesListContainer = styled.div<any>`
    display: flex;
    flex-direction: column;
    gap: 16px;


    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    &>* {
        flex: 1 1 400px;
    }
  `}
    ${(props: any): any => config(props).media.md`
      gap: 20px;

    `}
    ${(props: any): any => config(props).media.lg`
      gap: 32px;
    `}
    ${(props: any): any => config(props).media.xl`
  `}
`
